module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/core-js/symbol.js
// module id = 630
// module chunks = 23 41